import { isPlatform } from "@ionic/react";
import { useState, useEffect } from "react";
import {DeviceType} from "../modules/hooks/types/DeviceType";
import { BREAKPOINT_MOBILE, BREAKPOINT_DESKTOP } from "../constants/breakpoints";

export { BREAKPOINT_MOBILE, BREAKPOINT_DESKTOP };

const getInitialDevice = (): DeviceType => {
    if (typeof window === "undefined") return "desktop";
    const width = window.innerWidth;
    if (isPlatform("tablet")) return "tablet";
    if (isPlatform("mobile")) return "phone";
    if (width < BREAKPOINT_MOBILE) return "phone";
    if (width < BREAKPOINT_DESKTOP) return "tablet";
    return "desktop";
};

export const useDeviceType = (): DeviceType => {
    const [device, setDevice] = useState<DeviceType>(getInitialDevice);

    useEffect(() => {
        const checkDevice = (): void => {
            const width = window.innerWidth;
            if (isPlatform("tablet")) {
                setDevice("tablet");
            } else if (isPlatform("mobile")) {
                setDevice("phone");
            } else if (width < BREAKPOINT_MOBILE) {
                setDevice("phone");
            } else if (width < BREAKPOINT_DESKTOP) {
                setDevice("tablet");
            } else {
                setDevice("desktop");
            }
        };

        checkDevice();
        window.addEventListener("resize", checkDevice);
        return () => window.removeEventListener("resize", checkDevice);
    }, []);

    return device;
};
